export default __webpack_public_path__ + "media/images/mail/x-twitter-b29d820e31ef9608a4b8174b67c159b7.png";